import React, { useEffect, useState } from "react";
import "./Style.css";
import Loader from "../../Component/Loader/Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { getSurveyCriteriaList, getSurveyDetails, showToast } from "../Utils/utils";
import axios from "axios";
import { userServiceUrl } from "../Config/config";

const SurveyThree = (props) => {
  const [loading, setLoading] = useState(false);
  const [pos, setPos] = useState('');
  const [neg, setNeg] = useState('');
  let location = useLocation();
  let survey_id = new URLSearchParams(location.search).get('survey_id')
  const navigate = useNavigate()
  let isEdit = new URLSearchParams(location.search).get('edit')


  const AddSurveyCriteria = async () => {
    try {
      const data = {
        survey_id: survey_id,
        positive_feedback: pos,
        negative_feedback: neg,
      }
      let token = localStorage.getItem("token")
      const response = await axios.post(
        `${userServiceUrl}/provider/add-survey-feedback`,
        data,
        {
          headers: {
            "Content-Type": "application/json", Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status == 200) {
        showToast(response.data.message, "success")
        setTimeout(() =>
          navigate(`/survey-dashboard`)
          , 2000)
      }
    } catch (error) {
      // displayError(error)
      // console.error(error.response.data);
      showToast(error.response.data.message, "error");
      // throw error.response ? error.response.data : error;
    }
  }

  const getSurveyDetail = async () => {
    var res = await getSurveyDetails(survey_id)
    setPos(res.data?.positive_feedback)
    setNeg(res.data?.negative_feedback)

  }
  useEffect(() => {
    if (isEdit === 'true') {
      getSurveyDetail()
    }
  }, [isEdit])

  return (
    <>
      {loading && <Loader />}
      <div className="page-top">
        <div className='booking-top-container px-4 py-3'>
          <Link to="/survey-dashboard" style={{ textDecoration: 'none' }}>
            <img
              className="img-fluid left-arrow-img"
              src="./Images/left-arrow.svg"
              alt="arrow"
            />
          </Link>

        </div>
        <div className="page-wrapper mx-auto px-4">
          {/* Survey Step 2 */}
          <div className="">
            <div className="d-flex justify-content-between">
              {isEdit == 'true' ?
                <h3 className="provider-title">Edit Survey Step 3</h3>
                :
                <h3 className="provider-title">Survey Step 3</h3>
              }
              <img
                className="img-fluid"
                src="/Images/logo.svg"
                alt="logo image"
              />
            </div>
            <h6 className="login-title mt-2">Post Service Session Criteria</h6>

          </div>

          {/* <form className="form mt-3"> */}
          {/* Major Problem Criteria */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Positive Result Feedback </label>
            <textarea
              className="criteria-input statement"
              placeholder="Feedback summary"
              onChange={(e) => setPos(e.target.value)}
              value={pos}
            ></textarea>
            <div className="criteria-char">(Minimum 500 Characters)</div>
          </div>

          {/* Problem Statement */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Negative Result Feedback </label>
            <textarea
              className="criteria-input statement"
              placeholder="Feedback summary"
              onChange={(e) => setNeg(e.target.value)}
              value={neg}
            ></textarea>
            <div className="criteria-char">(Minimum 500 Characters)</div>
          </div>



          <div>
            {isEdit == 'true' ?
              <button className="continue-btn-res padding-btn" type="submit" onClick={() => AddSurveyCriteria()}>
                <span className="continuebtn-text">Update Survey</span>
              </button>
              :
              <button className="continue-btn-res padding-btn" type="submit" onClick={() => AddSurveyCriteria()}>
                <span className="continuebtn-text">Submit Survey</span>
              </button>
            }
          </div>
          {/* </form> */}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {};
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SurveyThree);